// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AggregateReadResponseEuRange } from './AggregateReadResponseEuRange';
import {
    AggregateReadResponseEuRangeFromJSON,
    AggregateReadResponseEuRangeFromJSONTyped,
    AggregateReadResponseEuRangeToJSON,
    AggregateReadResponseEuRangeToJSONTyped,
} from './AggregateReadResponseEuRange';
import type { HistoryDataValue } from './HistoryDataValue';
import {
    HistoryDataValueFromJSON,
    HistoryDataValueFromJSONTyped,
    HistoryDataValueToJSON,
    HistoryDataValueToJSONTyped,
} from './HistoryDataValue';

/**
 * Historical data for a specific value variable
 * @export
 * @interface HistoryValueData
 */
export interface HistoryValueData {
    /**
     * OPC UA browse path to the value variable (e.g. TemperatureController/CurrentValue)
     */
    browsePath: string;
    /**
     * OPC UA status code (e.g. Good, GoodNoData, BadNodeIdUnknown)
     */
    statusCode: string;
    /**
     * 
     */
    historyData: Array<HistoryDataValue>;
    /**
     * Continuation point for paging through large result sets
     */
    continuationPoint?: string | null;
    /**
     * 
     */
    engineeringUnits?: string;
    /**
     * 
     */
    valuePrecision?: number;
    /**
     * 
     */
    euRange?: AggregateReadResponseEuRange;
    /**
     * 
     */
    enumStrings?: Array<string>;
}

/**
 * Check if a given object implements the HistoryValueData interface.
 */
export function instanceOfHistoryValueData(value: object): value is HistoryValueData {
    if (!('browsePath' in value) || value['browsePath'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('historyData' in value) || value['historyData'] === undefined) return false;
    return true;
}

export function HistoryValueDataFromJSON(json: any): HistoryValueData {
    return HistoryValueDataFromJSONTyped(json, false);
}

export function HistoryValueDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryValueData {
    if (json == null) {
        return json;
    }
    return {
        
        'browsePath': json['browsePath'],
        'statusCode': json['statusCode'],
        'historyData': ((json['historyData'] as Array<any>).map(HistoryDataValueFromJSON)),
        'continuationPoint': json['continuationPoint'] === undefined ? undefined : json['continuationPoint'] === null ? null : json['continuationPoint'],
        'engineeringUnits': json['engineeringUnits'] == null ? undefined : json['engineeringUnits'],
        'valuePrecision': json['valuePrecision'] == null ? undefined : json['valuePrecision'],
        'euRange': json['euRange'] == null ? undefined : AggregateReadResponseEuRangeFromJSON(json['euRange']),
        'enumStrings': json['enumStrings'] == null ? undefined : json['enumStrings'],
    };
}

export function HistoryValueDataToJSON(json: any): HistoryValueData {
    return HistoryValueDataToJSONTyped(json, false);
}

export function HistoryValueDataToJSONTyped(value?: HistoryValueData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browsePath': value['browsePath'],
        'statusCode': value['statusCode'],
        'historyData': ((value['historyData'] as Array<any>).map(HistoryDataValueToJSON)),
        'continuationPoint': value['continuationPoint'],
        'engineeringUnits': value['engineeringUnits'],
        'valuePrecision': value['valuePrecision'],
        'euRange': AggregateReadResponseEuRangeToJSON(value['euRange']),
        'enumStrings': value['enumStrings'],
    };
}

